import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { ItemSelectorItemsComponent } from './item-selector-items/item-selector-items.component';
import { ItemSelectorItemsSelectedComponent } from './item-selector-items-selected/item-selector-items-selected.component';
import { ItemSelectorComponent } from './item-selector.component';

@NgModule({
  imports: [CommonModule, TrackingModule, UiModule],
  declarations: [
    ItemSelectorComponent,
    ItemSelectorItemsComponent,
    ItemSelectorItemsSelectedComponent,
  ],
  exports: [ItemSelectorComponent],
})
export class ItemSelectorModule {}
